/**
 * Dayyo 2026 - Main JS Entry Point
 */

import { initGSAP } from './modules/gsap-init';
import './modules/navigation';
import './modules/smoothScroll';
import './modules/lazyLoad';
import './modules/backToTop';

document.addEventListener('DOMContentLoaded', () => {
    document.documentElement.classList.remove('no-js');
    document.documentElement.classList.add('js');
    
    initGSAP();
});
